<template>
  <div>
    <div v-if="!timeType">
      <div class="content" v-if="endVal||endVal === 0">
        <v-countup class="count-up" :start-value="startVal" :end-value="endValue" :duration="2"></v-countup>
        <span  class="add" v-show="!countShow">
          +{{addVal}}
         <!-- <v-countup :start-value="0" :end-value="addVal" :duration="1"></v-countup> -->
        </span>
        <span class="circle" v-show="countShow">
          <el-progress :width="28" :stroke-width="1" type="circle" :percentage="percentage" color="blue" :show-text="false"></el-progress>
          <div class="countdown">{{countdown}}</div>
        </span>
      </div>
      <!-- 无数据时展示 -->
      <div v-else class="no_data">--</div>
      <p class="title">{{text}}</p>
    </div>
    <!-- 时间计算 -->
    <div v-else>
      <div class="content" v-if="endVal||endVal === 0">
        <div class="count-up">
          <v-countup :start-value="startHours" :end-value="hours" :duration="2"></v-countup>
          <span>:</span>
          <v-countup :start-value="startMinutes" :end-value="minutes" :duration="2"></v-countup>
          <span>:</span>
          <v-countup :start-value="startSeconds" :end-value="seconds" :duration="2"></v-countup>
        </div>
        <span  class="add" v-show="!countShow">
          +{{addHours?addHours+':':''}}{{addMinutes}}:{{addSeconds}}
        </span>
        <span class="circle" v-show="countShow">
          <el-progress :width="28" :stroke-width="1" type="circle" :percentage="percentage" color="blue" :show-text="false"></el-progress>
          <div class="countdown">{{countdown}}</div>
        </span>
      </div>
      <!-- 无数据时展示 -->
      <div class="no_data" v-else>--</div>
      <p class="title">{{text}}</p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "DataIncrease",
  props: {
    startVal: {
      type: [Number, String],
      default: 0,
    },
    endVal: {
      type: [Number, String],
      default: 0,
    },
    addVal: {
      type: [Number, String]
    },
    text: {
      type: String,
      default: '今日广告触达人次'
    },
    timeType: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      percentage: 100,
      countdown: 12,
      countShow: true,
      endValue: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      inter: null,
      inter2: null,
    }
  },
  computed: {
    startHours () {
      if (moment.duration(this.startVal*1000)._data.days) {
        // console.log(moment.duration(this.startVal*1000)._data.days*24 + moment.duration(this.startVal*1000)._data.hours, 'hour')
        return moment.duration(this.startVal*1000)._data.days*24 + moment.duration(this.startVal*1000)._data.hours
      } else {
        return moment.duration(this.startVal*1000)._data.hours
      }
    },
    startMinutes () {
      let min = moment.duration(this.startVal*1000)._data.minutes
      return min
    },
    startSeconds () {
      let sec = moment.duration(this.startVal*1000)._data.seconds
      return sec
    },
    endHours () {
      if (moment.duration(this.endVal*1000)._data.days) {
        return moment.duration(this.endVal*1000)._data.days*24 + moment.duration(this.endVal*1000)._data.hours
      } else {
        return moment.duration(this.endVal*1000)._data.hours
      }
    },
    endMinutes () {
      let min = moment.duration(this.endVal*1000)._data.minutes
      return min
    },
    endSeconds () {
      let sec = moment.duration(this.endVal*1000)._data.seconds
      return sec
    },
    addHours () {
      if (moment.duration(this.addVal*1000)._data.days) {
        return moment.duration(this.addVal*1000)._data.days*24 + moment.duration(this.addVal*1000)._data.hours
      } else {
        return moment.duration(this.addVal*1000)._data.hours
      }
    },
    addMinutes () {
      let min = moment.duration(this.addVal*1000)._data.minutes
      if (min < 10) {
        return '0' + min
      }
      return min
    },
    addSeconds () {
      let sec = moment.duration(this.addVal*1000)._data.seconds
      if (sec < 10) {
        return '0' + sec
      }
      return sec
    },
  },
  methods: {
    // 倒计时方法
    getFirst (v) {
      this.endValue = v
      if (moment.duration(v*1000)._data.days) {
        this.hours = moment.duration(v*1000)._data.days*24 + moment.duration(v*1000)._data.hours
      } else {
        this.hours = moment.duration(v*1000)._data.hours
      }
      this.minutes = moment.duration(v*1000)._data.minutes
      this.seconds = moment.duration(v*1000)._data.seconds
    },
    timeChange () {
      this.countShow = true
      this.countdown = 12
      this.percentage = 100
      // 倒计时开始，请求当前时间数据
      if (this.inter) clearInterval(this.inter)
      this.inter = setInterval(()=>{
        this.countdown -= 1
        // 倒计时结束，展示该数据
        if (this.countdown < 0) {
          clearInterval(this.inter)
          this.countShow = false
          this.endValue = this.endVal
          this.hours = this.endHours
          this.minutes = this.endMinutes
          this.seconds = this.endSeconds
        }
      }, 1000)

      // 进度条
      if (this.inter2) clearInterval(this.inter2)
      this.inter2 = setInterval(()=> {
        this.percentage -= 10/12
        if (this.countdown === 0 || this.countdown < 0) {
          this.percentage = 0
          clearInterval(this.inter2)
        }
      }, 100)
    }
  },
}
</script>

<style lang="scss" scoped>
.no_data{
  padding-top: 35px;
  padding-left: 40px;
  overflow: hidden;
  font-size: 28px;
  font-weight: bold;
}
.content {
  padding-top: 30px;
  padding-left: 40px;
  overflow: hidden;
  .count-up {
    float: left;
    height: 36px;
    line-height: 36px;
    font-size:28px;
    font-family:Akrobat-Bold;
    font-weight:bold;
    margin-right: 10px;
    color:rgba(40,39,41,1);
  }
  .add {
    float: left;
    height: 36px;
    line-height: 36px;
    font-size:18px;
    font-family:Akrobat-Bold,Akrobat;
    font-weight:bold;
    color:rgba(255,57,115,1);
  }
  .circle {
    display: inline-block;
    text-align: center;
    position: relative;
    top: 2px;
    .countdown {
      position: absolute;
      text-align: center;
      top: 49%;
      right: 50%;
      transform: translateX(50%) translateY(-50%);
    }
  }
}
.title {
  padding-top: 3px;
  padding-left: 40px;
  color:rgba(153,153,153,1);
}
</style>
